import React from "react";
import { Link } from "react-router-dom";
import BrilloLogo from "@/components/BrilloLogo";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-6">
      <BrilloLogo className="h-12 w-auto" />
      <h1 className="mt-8 font-display text-5xl text-[#333333]">404</h1>
      <p className="mt-2 text-[#666666]">La página que buscas no existe.</p>
      <Link
        to="/"
        className="mt-6 bf-btn-primary rounded-full px-6 py-3 font-semibold"
        data-testid="notfound-home-link"
      >
        Volver al inicio
      </Link>
    </div>
  );
}
